import React from 'react';
import './Header.css';
import Navbar from '../navbar/Navbar';
import { Link, useLocation } from 'react-router-dom';

function Header() {

  const scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  const location = useLocation();

  return (
    <header className="header">
      <div className="header-container">
        <Link to='/'>
          <img className="main-logo white-logo" src="/images/logo1.png" alt="logo" onClick={scrollToTop} />
        </Link>
        {/* info-container removed per layout update */}
      </div>
      {location.pathname === '/' && <Navbar scrollToTop={scrollToTop} />}
    </header>
  );
}

export default Header;
